import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/components/HomePage.vue'),
  },
  {
    path: '/corporateCulture',
    name: 'CorporateCulture',
    component: () => import('@/components/CorporateCulture.vue'),
  },
  { 
    path: '/about', 
    name: 'AboutView',
    component: () => import('@/components/AboutView.vue'),
    redirect: '/about/AboutPage', 
    children: [
      // 给“公司简介”一个单独的子路径（如 about-intro）
      { path: 'aboutPage', 
        name: 'AboutPage',
        component: () => import('@/components/AboutPage.vue')
      }, 
      // 品牌历程路径保持正确
      { path: 'brandHistory', 
        name: 'BrandHistory',
        component: () => import('@/components/BrandHistory.vue')
      },
      { path: 'CorporateCulture', 
        name: 'CorporateCulture',
        component: () => import('@/components/CorporateCulture.vue')
      },
      { path: 'brandPromotion', 
        name: 'brandPromotion',
        component: () => import('@/components/brandPromotion.vue')
      }
    ] 
  },
  { 
    path: '/productShowcase', 
    name: 'productShowcase',
    component: () => import('@/components/ProductShowcase.vue')
  },
  // { 
  //   path: '/productShowcase', 
  //   name: 'productShowcase',
  //   component: () => import('@/components/ProductShowcase.vue'), // 确保引入了组件
  //   children: [
  //     { path: '/productShowcase#chaye', name: '茶叶系列' }, 
  //     { path: '/productShowcase#chayin', name: '茶饮系列' },
  //     { path: '/productShowcase#chaqi', name: '茶器系列' },
  //     { path: '/productShowcase#chayan', name: '茶宴系列' },
  //     { path: '/productShowcase#chacang', name: '茶舱系列' }
  //   ]
  // },
  {
    path: '/groupControl',
    name: 'groupControl',
    component: () => import('@/components/groupControl.vue'),
  },
  {
    path: '/WxProductView',
    name: 'WxProductView',
    component: () => import('@/components/WxProductView.vue'),
  },
  {
    path: '/socialResponsibility', // 父路由路径
    name: 'socialResponsibility',
    // 父组件应为一个容器组件（而非直接用子组件），用于承载子路由
    component: () => import('@/components/socialResponsibilityContainer.vue'), 
    // 重定向到第一个子菜单的完整路径（与导航子菜单path一致）
    redirect: '/socialResponsibility/publicWelfare', 
    children: [
      {
        // 子路由用相对路径，完整路径为 /socialResponsibility/publicWelfare
        path: 'publicWelfare', 
        name: 'publicWelfare',
        component: () => import('@/components/social/publicWelfare.vue')
      },
      {
        path: 'agricultureView',
        name: 'agricultureView',
        component: () => import('@/components/social/agricultureView.vue')
      },
      {
        path: 'villageView',
        name: 'villageView',
        component: () => import('@/components/social/villageView.vue')
      },
      {
        path: 'HealthyChina',
        name: 'HealthyChina',
        component: () => import('@/components/social/HealthyChina.vue')
      }
    ]
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/components/ContactPage.vue'),
  },
  {
    path: '/news',
    name: 'NewsCenter',
    component: () => import('@/components/news/NewsList.vue')
  },
  {
    path: '/waterSourceLocation',
    name: 'WaterSourceLocation',
    component: () => import('@/components/WaterSourceLocation.vue'),
    // 添加重定向，点击一级菜单时默认跳转到第一个子路由
    redirect: '/waterSourceLocation/source', 
    // 二级菜单对应的子路由配置
    children: [
      {
        // 水源介绍 - 访问路径为 /waterSourceLocation/source
        path: 'source',
        name: 'WaterSource',
        component: () => import('@/components/waterSource/SourceIntroduction.vue')
      },
      {
        // 种植基地介绍 - 访问路径为 /waterSourceLocation/plant
        path: 'plant',
        name: 'PlantBase',
        component: () => import('@/components/waterSource/PlantBaseIntroduction.vue')
      },
      {
        // 工厂介绍 - 访问路径为 /waterSourceLocation/factory
        path: 'factory',
        name: 'Factory',
        component: () => import('@/components/waterSource/FactoryIntroduction.vue')
      }
    ]
  },
  {
    path: '/jobRecruitment',
    name: 'JobRecruitment',
    component: () => import('@/components/JobRecruitment.vue')
  },
  {
    path: '/publicWelfare',
    name: 'publicWelfare',
    component: () => import('@/components/publicWelfare.vue')
  },
  {
    path: '/responsibilityView',
    name: 'responsibilityView',
    component: () => import('@/components/responsibilityView.vue')
  },
  {
    path: '/news/detail/:newsData',
    name: 'NewsDetail',
    component: () => import('@/components/news/NewsDetail.vue')
  },
  {
    path: '/news/edit',
    name: 'NewsEditor',
    component: () => import('@/components/news/NewsEditor.vue')
  },
  {
    path: '/login',
    name: 'loginPage',
    component: () => import('@/components/loginPage.vue')
  },
  {
    path: '/siteMapView',
    name: 'SiteMapView',
    component: () => import('@/components/SiteMapView.vue')
  },
  {
    path: '/imageUploader',
    name: 'ImageUploader',
    component: () => import('@/components/ImageUploader.vue')
  }
]


const router = new VueRouter({
  // mode: 'history',  // 使用 HTML5 history 模式
  base: process.env.BASE_URL,
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ x: 0, y: 0 })
    })
  },
  routes
})
// 解决重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只捕获重复导航的错误，其他错误正常抛出
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}


// 路由跳转前：启动进度条（监听页面资源）
router.beforeEach((to, from, next) => {
  Vue.prototype.$pageLoading.startLoading();
  next();
});

// 路由跳转后：组件渲染完，结束进度条
router.afterEach(() => {
  // 延迟一小段时间（确保组件DOM和资源加载完成）
  setTimeout(() => {
    Vue.prototype.$pageLoading.finishLoading();
  }, 100);
});

// 在路由守卫中补充检测
router.beforeEach((to, from, next) => {
  const MOBILE_WIDTH_THRESHOLD = 768;
  const isSmallScreen = window.innerWidth < MOBILE_WIDTH_THRESHOLD;
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isOnMobileSite = window.location.hostname.includes('m.3pg.cn');
  
  if ((isMobileDevice || isSmallScreen) && !isOnMobileSite) {
    window.location.href = 'http://m.3pg.cn';
    return;
  }
  
  next();
});


export default router
